import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ISelectSchemaOption, IFormSchemaItem } from '../../types/datatypes';
import { FormSchemaService } from '../../core/services/form-schema.service';

@Component({
	selector: 'app-schema-form-builder',
	templateUrl: './schema-form-builder.component.html',
	styleUrls: ['./schema-form-builder.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class SchemaFormBuilderComponent implements OnInit {
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input({ required: true }) schemas!: IFormSchemaItem[];

	@Input() data: { [k: string]: any } | null = null;

	@Input() form: FormGroup;

	@Input() formGroupName: string = null;

	@Output() dataChange = new EventEmitter<{ [k: string]: any }>();

	constructor(
		private formBuilder: FormBuilder,
		private formSchemaService: FormSchemaService,
	) { }

	public getValue(schema: IFormSchemaItem) {
		if (!this.data || !this.data[schema.name]) {
			return null;
		}
		return this.data[schema.name];
	}

	public getOptions(schema: IFormSchemaItem): (string | ISelectSchemaOption)[] {
		return schema.options ?? [];
	}

	ngOnInit() {
		if (!this.form) {
			const fields = this.formSchemaService.formGroupFromSchemas(this.schemas);
			this.form = this.formBuilder.group(fields);
		}
	}

	hasErrors(fieldName: string): boolean {
		/**
		 * Access nested group field if defined.
		 */
		const field = this.formGroupName ? `${this.formGroupName}.${fieldName}` : fieldName;
		return this.form.touched && this.form.get(field).touched && !!Object.keys(this.form.get(field)?.errors ?? {}).length;
	}
}
